import NativeIcon, { type SvgIconProps } from './NativeIcon';

/**
 * Document/factsheet glyph from the GX dev-handoff (a sheet with a folded
 * top-right corner and text lines). Used for the "open factsheet" affordance.
 */
const FactsheetIcon = (props: SvgIconProps) => {
  return (
    <NativeIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 14 14'
    >
      <path d='M11.6101 5.0085C11.5824 4.94521 11.5437 4.88734 11.4958 4.83758L7.99575 1.33758C7.946 1.28965 7.88813 1.25094 7.82483 1.22325C7.80733 1.21508 7.78867 1.21042 7.77 1.204C7.72118 1.18745 7.67037 1.17745 7.61892 1.17425C7.60667 1.17308 7.59558 1.16667 7.58333 1.16667H3.5C2.85658 1.16667 2.33333 1.68992 2.33333 2.33333V11.6667C2.33333 12.3101 2.85658 12.8333 3.5 12.8333H10.5C11.1434 12.8333 11.6667 12.3101 11.6667 11.6667V5.25C11.6667 5.23775 11.6603 5.22667 11.6591 5.21383C11.6559 5.16238 11.6459 5.11158 11.6293 5.06275C11.6239 5.04408 11.6175 5.026 11.6101 5.0085ZM9.67517 4.66667H8.16667V3.15817L9.67517 4.66667ZM3.5 11.6667V2.33333H7V5.25C7 5.40471 7.06146 5.55308 7.17085 5.66248C7.28025 5.77187 7.42862 5.83333 7.58333 5.83333H10.5L10.5012 11.6667H3.5Z' />
      <path d='M4.66667 7H9.33333V8.16667H4.66667V7ZM4.66667 9.33333H9.33333V10.5H4.66667V9.33333ZM4.66667 4.66667H5.83333V5.83333H4.66667V4.66667Z' />
    </NativeIcon>
  );
};

export default FactsheetIcon;
